import { NgModule } from '@angular/core';
import { AngularMaterialModule } from '../../material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectiveModule } from '../../directives/directive.module';
import { LauftextModule } from '../lauftext/lauftext.module';
import { CruisefilterComponent } from './cruise/cruisefilter/cruisefilter.component';
import { CruisezieleComponent } from './cruise/cruiseziele/cruiseziele.component';
import { CruisesearchtypeComponent } from './cruise/cruisesearchtype/cruisesearchtype.component';
import { CarrentfilterComponent } from './carrent/carrentfilter/carrentfilter.component';
import { CityComponent } from './carrent/city/city.component';
import { CarrentreisendeComponent } from './carrent/carrentreisende/carrentreisende.component';
import { CarrenttypeComponent } from './carrent/carrenttype/carrenttype.component';
import { CruiseReisendeComponent } from './cruise/cruisereisende/cruisereisende.component';
import { CleverdatepickerModule } from '../cleverdatepicker/cleverdatepicker.module';
import { FerienhauserfilterComponent } from './ferienhauser/ferienhauserfilter/ferienhauserfilter.component';
import { FerienhauserzielComponent } from './ferienhauser/ferienhauserziel/ferienhauserziel.component';
import { HotelfilterComponent } from './hotel/hotelfilter/hotelfilter.component';
import { ReisezielComponent } from './hotel/reiseziel/reiseziel.component';
import { AirportComponent } from './airport/airport.component';
import { DateComponent } from './date/date.component';
import { DauerComponent } from './dauer/dauer.component';
import { TravellerComponent } from './traveller/traveller.component';
import { DoublesliderModule } from '../doubleslider/doubleslider.module';
import { RoomtypeComponent } from './hotel/roomtype/roomtype.component';
import { ReilComponent } from './hotel/reil/reil.component';
import { FlugfilterComponent } from './flugfilter/flugfilter.component';
import { ExtrafiltersModule } from '../extrafilters/extrafilters.module';
import { SelectionlistComponent } from './selectionlist/selectionlist.component';
import { CarrentextrafiltersModule } from '../carrentextrafilters/carrentextrafilters.module';
import { SearchlistComponent } from './cruise/searchlist/searchlist.component';
import { FerienhauserextrafiltersModule } from '../ferienhauserextrafilters/ferienhauserextrafilters.module';
import { CruiseextrafiltersModule } from '../cruiseextrafilters/cruiseextrafilters.module';
import { GlobalFilterComponent } from './global/global.component';
import { PipeModule } from '@app/pipe/pipe.module';
import { ZielComponent } from './hotel/reiseziel/ziel/ziel.component';
import { FerienhauserreisendeComponent } from './ferienhauser/ferienhauserreisende/ferienhauserreisende.component';
@NgModule({
    declarations: [
        CruisefilterComponent,
        CruisezieleComponent,
        CruisesearchtypeComponent,
        CruiseReisendeComponent,
        CarrentfilterComponent,
        CityComponent,
        CarrentreisendeComponent,
        CarrenttypeComponent,
        FerienhauserfilterComponent,
        FerienhauserzielComponent,
        HotelfilterComponent,
        ReisezielComponent,
        AirportComponent,
        DateComponent,
        DauerComponent,
        TravellerComponent,
        RoomtypeComponent,
        ReilComponent,
        FlugfilterComponent,
        SelectionlistComponent,
        SearchlistComponent,
        GlobalFilterComponent,
        ZielComponent,
        FerienhauserreisendeComponent
    ],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        LauftextModule,
        CleverdatepickerModule,
        DoublesliderModule,
        AngularMaterialModule,
        DirectiveModule,
        PipeModule,
        ExtrafiltersModule,
        CarrentextrafiltersModule,
        FerienhauserextrafiltersModule,
        CruiseextrafiltersModule
    ],

    exports: [
        HotelfilterComponent,
        FlugfilterComponent,
        CarrentfilterComponent,
        CruisefilterComponent,
        GlobalFilterComponent,
        FerienhauserfilterComponent
    ],

    providers: [],
})

export class FilterModule { }
